const ToggleActionTypes = {
  TEACHER_ASSESSMENTS_ON: 'TEACHER_ASSESSMENTS_ON',
  TEST_SCORES_ON: 'TEST_SCORES_ON',
};

export default ToggleActionTypes;
